import * as UI from '@brewlogix/blx-ui'
import * as React from 'react'

import Image from 'next/image'
import LegacyFavoritesButton from 'src/features/favorites/components/LegacyFavoritesButton'
import { FavoriteType } from 'src/features/favorites/types/enums/FavoriteType'
import { useLocationSlugStore } from 'src/features/locations/state/useLocationSlugStore'
import { CompositeProduct } from 'src/types/schema/graphql'
import getDefaultIconByProduct from 'src/util/helpers/getDefaultIconByProduct'
import AvailabilityPills from './AvailabilityPills'

interface IBrewCard {
    brew: CompositeProduct
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
}

const BrewCard: React.FC<IBrewCard> = ({ brew, onClick }) => {
    const currentLocation = useLocationSlugStore((state) => state.locationData)
    const locationAvailability = brew.locationRelationships?.find(
        (item) => item?.location?.id === currentLocation?.id
    )
    const defaultIcon = getDefaultIconByProduct(brew)
    const abv = brew.abv ? (brew?.abv || brew.style.abvMax) + '%' : null
    return (
        <>
            <UI.Card
                key={brew.id}
                format='inline'
                customClasses={`brew-card border-none border-t-1 border-t-gray-100  before:content-[attr(data-availability)] cursor-pointer rounded-md h-36 hover:drop-shadow-md  hover:border-px hover:border-gray-50  transition  ease duration:150`}
                onClick={onClick}
            >
                <div className='flex w-full flex-row'>
                    <div className='relative mr-4 h-28 w-28 flex-shrink-0 rounded-md border-px border-gray-100'>
                        {brew.assets?.length > 0 ? (
                            <UI.Media
                                asset={brew?.assets[0]}
                                customWrapperClasses='bg-gray-100 rounded-md'
                                width={300}
                                height={300}
                                alt={`Logo Image for ${brew?.title}`}
                            />
                        ) : (
                            <div className='rounded-lg'>
                                <Image
                                    src={defaultIcon}
                                    alt={`Default ${brew?.__typename} Icon`}
                                    width={300}
                                    height={300}
                                />
                            </div>
                        )}
                    </div>
                    <div className='flex w-full flex-col space-y-1'>
                        <div className=' flex w-full flex-row justify-between'>
                            <UI.Heading size='h6'>{brew.title}</UI.Heading>
                        </div>
                        <div className='flex flex-col items-start gap-2'>
                            <span className='inline text-gray-400'>
                                {brew?.styleAlias || brew?.style?.title}
                                <span className='mx-2 mb-1 inline-flex h-1 w-1 rounded-full bg-gray-200' />
                                {abv}
                            </span>
                            {locationAvailability?.available && (
                                <div className='flex items-center gap-2'>
                                    <AvailabilityPills availability={locationAvailability} />
                                </div>
                            )}

                            {/* TODO: Add When avail */}
                            {/* {brew?.primaryFlavorNotes && (
                                <FlavorProfiles flavorNotes={brew?.primaryFlavorNotes} />
                            )} */}
                        </div>
                    </div>
                    <div className='relative flex h-full min-h-full flex-col items-end justify-between'>
                        <LegacyFavoritesButton
                            type={FavoriteType.Product}
                            heartSize='md'
                            ariaLabel={`Add ${brew?.title} to Your Favorites`}
                            item={brew}
                        />
                        <span></span>
                    </div>
                </div>
            </UI.Card>
            <div className='border-t-px border-t-gray-100' />
        </>
    )
}

export default BrewCard
